'use client';

import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';

const ReCAPTCHA = dynamic(() => import('react-google-recaptcha'), {
  ssr: false,
});

type LazyRecaptchaProps = {
  siteKey: string;
  onChange: (token: string | null) => void;
};

const LazyRecaptcha = ({ siteKey, onChange }: LazyRecaptchaProps) => {
  const [show, setShow] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: '200px' },
    );

    io.observe(containerRef.current);

    return () => io.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {show ? <ReCAPTCHA sitekey={siteKey} onChange={onChange} /> : null}
    </div>
  );
};

export { LazyRecaptcha };
